export default __webpack_public_path__ + "static/28281-5dc4825519e2e014e90c8a6441975a96.jpg";